import propTypes from 'prop-types';

import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';

const renderTooltipContent = (modifier, children) => (
  <div className={`tooltip-body tooltip-body--top-center ${modifier}`}>
    <div className="tooltip-body__content">{children}</div>
  </div>
);

export const Tooltip = (props) => {
  const { withIcon, modifier, children } = props;
  const sharedClassNames = 'tooltip-container';

  if (withIcon) {
    return (
      <span className={sharedClassNames}>
        <span className="tooltip-body__trigger">
          <PesIcon class="actions-block__cta-icon" size={pesIconSizes.NANO}>
            information_stroke
          </PesIcon>
        </span>
        {renderTooltipContent(modifier, children)}
      </span>
    );
  }

  return (
    <div className={`tooltip-container--open ${sharedClassNames}`}>
      {renderTooltipContent(modifier, children)}
    </div>
  );
};

Tooltip.propTypes = {
  withIcon: propTypes.bool,
  modifier: propTypes.string,
  children: propTypes.oneOfType([propTypes.string, propTypes.element]).isRequired
};

Tooltip.defaultProps = {
  withIcon: true,
  modifier: ''
};
